import { Tooltip, Link, Box, Chip } from "@mui/material";
import dayjs from "dayjs";
import { ORDER_STATUS, getFileNameFromUrl } from "../../../utils";
import NumericLabel from "../../../components/NumericLabel";
import config from "../../../config";

export const getOrdersColumns = () => [
  {
    field: "fl_dept_name",
    headerName: "Department",
    sortable: false,
    width: 160,
    renderCell: (params) => (
      <Tooltip title={params.value}>
        <span>{params.value}</span>
      </Tooltip>
    ),
  },
  {
    field: "fl_class_name",
    headerName: "Category",
    width: 160,
    renderCell: (params) => (
      <Tooltip title={params.value}>
        <span>{params.value}</span>
      </Tooltip>
    ),
  },
  {
    field: "fl_sub_name",
    headerName: "Planogram",
    width: 160,
    renderCell: (params) => (
      <Tooltip title={params.value}>
        <span>{params.value}</span>
      </Tooltip>
    ),
  },
  {
    field: "planogram",
    headerName: "Planogram #",
    width: 130,
    renderCell: (params) => (
      <Tooltip title={params.value ? getFileNameFromUrl(params.value) : ""}>
        <Link
          href={config.PogFileBasePath.concat(params.value)}
          target="_blank"
          rel="noreferrer noopener"
        >
          {getFileNameFromUrl(params.value)}
        </Link>
      </Tooltip>
    ),
  },
  {
    field: "po_number",
    headerName: "PO Number",
    width: 120,
  },
  {
    field: "order_qty",
    headerName: "Order Qty.",
    width: 130,
  },
  {
    field: "order_cost",
    headerName: "Order Cost",
    width: 130,
    renderCell: (params) =>
      !!params.value ? <NumericLabel isCurrency value={params.value} /> : "",
  },
  {
    field: "upc",
    headerName: "UPC",
    width: 130,
  },
  {
    field: "model",
    headerName: "Model",
    width: 130,
  },
  {
    field: "short_description",
    headerName: "Description",
    width: 130,
  },
  {
    field: "status",
    headerName: "Status",
    width: 150,
    renderCell: (params) => {
      let chipParams = {};
      if (!params.row.status) {
        return <></>;
      }
      if (params.row.status === ORDER_STATUS.pending) {
        chipParams = { label: params.row.status };
      } else {
        chipParams = { label: params.row.status, color: "success" };
      }
      return (
        <Box sx={{ mt: -0.1 }}>
          <Chip size="small" {...chipParams} />
        </Box>
      );
    },
  },
  {
    field: "release_date_time",
    headerName: "Release Date & Time",
    width: 175,
    renderCell: (params) =>
      !!params.value ? (
        <Tooltip title={dayjs(params.value).format("MM/DD/YYYY HH:mm")}>
          <span>{dayjs(params.value).format("MM/DD/YYYY HH:mm")}</span>
        </Tooltip>
      ) : (
        ""
      ),
  },
];
